import React from "react";

/**
 * Eslabones de la fila de acciones (copiar el link de confirmación). Misma
 * familia que el resto: grilla de 24, trazo de 2, puntas redondeadas y
 * `currentColor`.
 */
export default function LinkIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      height={props.height}
      width={props.width}
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ ...props.style, cursor: "pointer" }}
      {...props}
    >
      <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" />
    </svg>
  );
}

LinkIcon.defaultProps = {
  height: `2.2rem`,
  width: `2.2rem`,
  color: "currentColor",
};
